import StoreInput from "@/components/Inputs/StoreInput.vue";

export default {
	data() {
		return {
			filterStore: {
				name: "",
				_id: ""
			}
		};
	},
	watch: {
		"filterStore._id": {
			handler(val) {
				let fieldName = "store";
				if (val !== "") {
					this.$set(this.kvFilter, fieldName, { k: fieldName, t: "id", v: val });
				} else {
					this.$delete(this.kvFilter, fieldName);
				}
			},
			immediate: true
		}
	},
	components: {
		StoreInput
	}
};
